import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LinkedWebsite {
  name: string;
  api_token: string;
}

export interface LinkedWebsiteDetaiInfor {
  errors: unknown;
  LinkedWebsite: LinkedWebsite;
  isAuthenticated: boolean;
}

@Module
export default class LinkedWebsiteDetail
  extends VuexModule
  implements LinkedWebsiteDetaiInfor
{
  errors = {};
  LinkedWebsite = {} as LinkedWebsite;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get LinkedWebsiteDetail() {
    return this.linkedWebsiteDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.LINKED_WEBSITE_DETAIL_DATA](LinkedWebsite) {
    this.linkedWebsiteDetailData = LinkedWebsite;
  }
  @Action
  [Actions.LINKED_WEBSITE_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/linked_websites",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.LINKED_WEBSITE_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
